module.exports = __webpack_public_path__ + "img/bus-alt.02b6ae35.svg";